import { Box } from '@mui/material'
import { ReactComponent as PlusIcon } from 'assets/plan_edit_plus_logo.svg'
import { COLORS } from 'styles/colors'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
interface BottomButtonProps {
	onClickListButton: () => void
	textDescriptionForClickButton: string
}
export const BottomButton = ({
	textDescriptionForClickButton,
	onClickListButton,
}: BottomButtonProps) => {
	return (
		<>
			{textDescriptionForClickButton && onClickListButton && (
				<Box
					onClick={() => onClickListButton()}
					sx={{
						zIndex: '1000',
						position: 'fixed',
						bottom: '10px',
						left: '10px',
						width: '90%',
						backdropFilter: 'blur(2px)',
						borderRadius: '8px',
						background: 'rgba(255, 255, 255, 0.70)',
						display: 'flex',
						flexDirection: 'row',
						gap: '8px',
						alignItems: 'center',
						cursor: 'pointer',
					}}
				>
					<PlusIcon height='24px' width='24px' stroke={COLORS.secondary} />
					<TypographySecondary14>
						{textDescriptionForClickButton}
					</TypographySecondary14>
				</Box>
			)}
		</>
	)
}
